import React, { useState, useRef, useEffect } from "react";
import BackButton from "./Backbutton";
import { useNavigate, useParams } from "react-router-dom";
import RippleInitializer from "./RippleInitializer";
import Title from "./Title";
import "./common.css"
import PageHeading from "../common/PageHeading";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";
const Blessings = () => {
  const { id } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);
  const listRef = useRef(null);
  const [artists, setArtists] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const scrollTimeout = useRef(null);

  const navigate = useNavigate();
const [isMounted, setIsMounted] = useState(false);
let NewUsername = "";

const pathArray = window.location.pathname.split("/").filter(Boolean);

if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
} else {
    NewUsername = pathArray[0] 
}

let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
console.log(newImgUrl);
useEffect(() => {
  const timer = setTimeout(() => setIsMounted(true), 150); // small delay
  return () => clearTimeout(timer);
}, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
      const fetchBlessings = async () => {
          try {
              const res = await apiHandler.post("/guest/fetch-feature", {
                  _id: id,
                  category : "Blessings"
              });
              console.log(res);
              if (res) {
                let temp = res.blessings
                    temp.push(res.blessings[0])
                  setArtists(temp);
              
              }
          } catch (err) {
              console.error("Guest login error:", err);
          }
      };
      
      fetchBlessings();
  },[])

  // const artists = [
  //   {
  //     title: "Our Blessings",
  //     text: "Thank you for Being Part of our wedding ",
  //     name: "Harish",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl:
  //       "https://diqmdwhttngxa.cloudfront.net/7326/16652/Sahiba_Anchit_Wedding-951_960.jpg",
  //   },
  //   {
  //     title: "Caring Mother",
  //     text: "My dear daughter, I am so proud of the woman you have become. Your strength, compassion, and kindness have always inspired me, and I know that you will bring so much Joy and love to your marriage. ",
  //     name: "~ Sangeeta Chopra ~",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl:
  //       "https://youthincmag.com/wp-content/uploads/2019/04/Wedding-trends-pinterest.jpg",
  //   },
  //   {
  //     title: "Bossy Father",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Mohit",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl:
  //       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOltU3uLRvP2EeVAp_VEQU-0WK1PIDlXLTXw&s",
  //   },
  //   {
  //     title: "Jab We Met",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Suresh",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl:
  //       "https://blog.venuelook.com/wp-content/uploads/2023/01/wedding-dance.jpg",
  //   },
  //   {
  //     title: "Jab We Met",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Kohli",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //   },
  //   {
  //     title: "Jab We Met",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Dhoni",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //   },
  //   {
  //     title: "Jab We Met",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Rohit",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //   },
  //   {
  //     title: "Jab We Met",
  //     text: "Lorem yes no what are you Lorem yes no what are you Lorem yes no what are you ",
  //     name: "Yuvraj",
  //     description: `Dom Dolla is one of the latest Australian DJ/Producers to break globally following a succession of releases like “Take It”, “San Frandisco” & “Pump The Brakes”. Dom’s unique blend of house music has amassed over 300 million+ streams, Platinum-certified records, ARIA Award for Best Dance Release, back to back Beatport #1’s, US Billboard Dance top 10’s, triple j’s hottest 100, Shazam & Spotify Global top 100 charts.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=HidnJ9jEQ5aK-dKZEZWdLw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/205i7E8fNVfojowcQSfK9m?utm_source=generator",
  //     },
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //   },
  //   {
  //     title: "Last end",
  //     text: "You can click to exit",
  //     name: "Retika Chopra",
  //     description: `Tom Gaynor, better known by his stage name “Allday”, is an Australian rapper from Adelaide, South Australia. Allday became active in 2011, when Gaynor began uploading his music for free online. Millennial rapper Allday got his break with a pair of radio hits in his home country of Australia in 2014. "Right Now" and "You Always Know the DJ" were included on his debut album, Startup Cult. Since his debut, Allday continues to establish himself as a household name with tracks like “Wonder Drug” and “Protection” which received ARIA Gold awards.`,
  //     spotify: {
  //       profileUrl:
  //         "https://open.spotify.com/artist/2Ltr0s15RyvsjqWzSmiSRs?si=uTbBZc32RhC75qp7tlOfzw",
  //       embedUrl:
  //         "https://open.spotify.com/embed/artist/2Ltr0s15RyvsjqWzSmiSRs?utm_source=generator",
  //     },
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //   },
  // ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1025);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (listRef.current && isMobile) {
      const activeItem = listRef.current.children[activeIndex];
      if (activeItem) {
        listRef.current.scrollTo({
          top: activeItem.offsetTop,
          behavior: "smooth",
        });
      }
    }
  }, [activeIndex, isMobile, artists]);

  const getTransform = () => {
    if (isMobile) {
      const itemHeight = 130;
      const margin = 16;
      return `translateY(-${activeIndex * (itemHeight + margin)}px)`;
    } else {
      const itemWidth = 130;
      const margin = 10;
      return `translateX(-${activeIndex * (itemWidth + margin)}px)`;
    }
  };

  const handleWheel = (event) => {
    if (
      (activeIndex === artists.length - 1 && event.deltaY > 0) ||
      (activeIndex === 0 && event.deltaY < 0)
    ) {
      event.preventDefault();
      return;
    }

    if (
      (activeIndex === artists.length - 2 && event.deltaY > 0) ||
      (activeIndex === artists.length - 1 && event.deltaY > 0)
    ) {
      event.preventDefault();
      return;
    }

    if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
    scrollTimeout.current = setTimeout(() => {
      if (event.deltaY < 0) {
        setActiveIndex((prev) => Math.max(prev - 1, 0));
      } else {
        setActiveIndex((prev) => Math.min(prev + 1, artists.length - 1));
      }
    }, 100);
  };

  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY;
    touchEndY.current = e.touches[0].clientY;
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    touchEndY.current = e.touches[0].clientY;
    if (Math.abs(touchEndY.current - touchStartY.current) > 10) {
      setIsDragging(true);
    }
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;

    const touchDistance = touchStartY.current - touchEndY.current;
    if (touchDistance > 50) {
      if (activeIndex < artists.length - 2) {
        setActiveIndex((prev) => Math.min(prev + 1, artists.length - 1));
      }
    } else if (touchDistance < -50) {
      if (activeIndex > 0) {
        setActiveIndex((prev) => Math.max(prev - 1, 0));
      }
    }
  };

  const handleDragStart = (event) => {
    setIsDragging(true);
    setStartX(event.clientX);
  };

  const handleDragEnd = (event) => {
    setIsDragging(false);
    const delta = event.clientX - startX;

    if (
      (activeIndex === artists.length - 2 && delta < 0) ||
      (activeIndex === artists.length - 1 && delta > 0)
    ) {
      // Prevent dragging forward if the second-to-last or last item is active
      return;
    }

    if (delta > 50) {
      // Dragging right
      if (activeIndex > 0) {
        setActiveIndex((prev) => Math.max(prev - 1, 0));
      }
    } else if (delta < -50) {
      // Dragging left
      if (activeIndex < artists.length - 1) {
        setActiveIndex((prev) => Math.min(prev + 1, artists.length - 1));
      }
    }
  };

  
  useEffect(()=>{

  },[activeIndex])
console.log(artists)
  return (
    <div
      style={{ backgroundColor: "black", height: "100svh" }}
      className="bgblackornot"
    >
      <RippleInitializer />

      <div
        className="blessing "
        style={{ height: "100svh" }}
        onWheel={handleWheel}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleDragStart}
        onMouseUp={handleDragEnd}
        onMouseMove={(e) => {
          if (isDragging) {
            handleDragEnd(e);
          }
        }}
      >
        <ul
          className=" grid-cols-12 100svh"
          ref={listRef}
          style={{ transform: getTransform() }}
        >
          {artists.map((artist, i) => {
            const isLastItem = i === artists.length - 1;
            const isSecondLastActive = activeIndex === artists.length - 2;
            const isActive = isLastItem
              ? isSecondLastActive
              : activeIndex === i;

            return !isLastItem || (isLastItem && isSecondLastActive) ? (
              <li
                key={i}
                style={{
                  minWidth: isLastItem ? "60%" : " ",
                  minHeight: isLastItem ? "50%" : "",
                  maxHeight: isLastItem ? "100%" : "",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className={`item ${isLastItem ? "is-last" : ""} ${
                  isActive ? "active" : ""
                }`}
                onClick={() => {
                  if (!isActive) {
                    setActiveIndex(i);
                  }
                }}
              >
                <div
   style={{
  backgroundImage: `url(${newImgUrl + artist.bgImg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  filter:  isMounted ? "blur(0px)" : "blur(12px)",
  transition: "filter 1.2s ease-in-out",
  zIndex: 0,
}}

  ></div>
                <div className=" toptext">
                  <h4 className="hideinmobile ">{artist.name}</h4>
                </div>
                {/* <h3 style={{width:"90%"}}  className="text-center hideinpc  bg-white/0 py-[30px] px-[40px] border-[3px] border-white text-white p-4">{ artist.title}</h3> */}
                <h3>{artist.heading}</h3>

                <div
                  className="section-content "
                  style={{
                    padding: isLastItem ? "0px" : isMobile ? "12px" : "40px",
                  }}
                >
                  <div
                    className={
                      isLastItem
                        ? "innerdiv text-white p-0"
                        : isActive || isMobile
                        ? "innerdiv top-[40px] right-[40px] bottom-[40px] left-[40px] bg-white/0 py-[30px] px-[40px] border-[3px] border-white text-white p-2"
                        : ""
                    }
                    style={{
                      justifyContent: !isMobile
                        ? ""
                        : activeIndex === 0
                        ? ""
                        : "center",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        bottom: "0",
                        height: isLastItem ? "90%" : isMobile ? "" : "70%",
                        width: "100%",
                        opacity: isActive ? "1" : "0",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",

                        justifyContent:
                          activeIndex === 0 || isLastItem ? "center" : "end ",
                        alignItems: "center",
                      }}
                    >
                      <div>{isLastItem ? "" : <h3>{artist.title}</h3>}</div>
                      {activeIndex === 0 && (
                        <>
                          {/* <div className="flex flex-col justify-center items-center ourstory p-5 py-0">
                            <div
                              className="p-1   style-script-regular"
                              style={{ fontSize: "6vh" }}
                            >
                              {artist.title}
                            </div>
                            <BackButton
                              style={{
                                height: "45px",
                                maxWidth: "45px",
                                borderRadius: "100%",
                                position: "absolute",
                                left: "-4%",
                                top: "20%",
                              }}
                            >
                              <img
                                style={{
                                  height: "45px",
                                  maxWidth: "45px",
                                  borderRadius: "100%",
                                }}
                                src="assets/img/ic_back_arrow (1).svg"
                                alt="Back"
                                className="mobileversionarrow hideinmobile "
                              />
                            </BackButton>

                            <div style={{ height: "1.2rem", width: "100%" }}>
                              <img
                                className="mobileversion "
                                style={{
                                  height: "100%",
                                }}
                                src="assets/img/ic_weddingline.svg"
                                alt=""
                              />
                            </div>
                          </div> */}

                          <div className="ourstory blessings" style={{fontFamily: 'Baby Givoni'}}>
                            <Title title={artist.heading} color={true}/>
                          </div>

                          <div
                            className="w-full flex justify-center  blessingimage"
                            style={{
                              padding: isMobile ? "" : "10px",
                            }}
                          >
                            <img
                              style={{
                                position: "relative",
                                filter: "invert(100%)",
                                maxWidth: "90px",
                              }}
                              src="/img/ic_heart_ring.svg"
                              alt=""
                            />
                          </div>
                        </>
                      )}

                      {isLastItem ? (
                        <div
                          style={{
                            minHeight: "100%",
                            minWidth: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="text-center p-1 mb-1"
                            style={{
                              width: "100%",
                              backgroundColor: "#00000075",
                            }}
                          >
                            <div className="w-full flex justify-center mt-2">
                              <img
                                style={{
                                  position: "relative",
                                  filter: "invert(100%)",
                                  maxWidth: "90px",
                                  height: "4rem",
                                }}
                                src="/img/ic_heart_ring.svg"
                                alt=""
                              />
                            </div>
                            <div
                              className="p-2 pb-0"
                              style={{
                                fontSize: "17px",
                                lineHeight: "1.6",
                                textAlign: "justify",
                                textAlignLast: "center",
                              }}
                            >
                              {artist.blessingMsg}
                            </div>
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "1.6",
                                textAlign: "justify",
                                textAlignLast: "center",
                                fontWeight: "bolder",
                              }}
                              className="p-2"
                            >
                              {artist.name}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className={`${isMobile ? "" : "nametext"}`}>
                            {activeIndex !== 0 && (
                              <div>
                                <div
                                  style={{
                                    fontWeight: "500",
                                    fontSize: isMobile ? "30px" : "40px",
                                  }}
                                >
                                  {artist.heading}
                                </div>
                              </div>
                            )}
                            <div
                              className="p-4 py-0 pb-0 flex"
                              style={{ justifyContent: "center" }}
                            >
                              <div
                                style={{
                                  fontSize: isMobile ? "19px" : "1.6rem",
                                  lineHeight: isMobile ? " 1.6" : "1.4",
                                  textAlign: "justify",
                                  textAlignLast: "center",
                                  padding: isMobile ? "" : "20px",
                                }}
                              >
                                {artist.blessingMsg}
                              </div>
                            </div>
                            <div className="p-3 pt-0 pb-0">
                              <div
                                style={{
                                  fontSize: isMobile ? "19px" : "1.5rem",
                                  fontWeight: "bolder",
                                }}
                              >
                                {artist.name}
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {isLastItem && (
                        <div className="w-full buttonintab   absolute"
                        style={{
                          bottom: isMobile ? "5%" : "25%",
                          zIndex: "9999999",
                        }}>
                          <button
                            className="edit-button buttonripple   "
                           
                            onClick={handleBackClick}
                          >
                            <span style={{ padding: "20px",fontSize:'16px' }}>Exit</span>
                          </button>
                        </div>
                      )}
                    </div>
                    {isLastItem ? (
                      ""
                    ) : (
                      <div
                        className="prevnetx mb-3"
                        style={{ opacity: isActive ? "1" : "0" }}
                      >
                        <button
                          className={`button1 px-4 p-2 ${
                            activeIndex === 0 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            setActiveIndex((prev) => Math.max(prev - 1, 0))
                          }
                        >
                          <img
                            style={{
                              height: "50px",
                              filter:
                                "invert(1) sepia(1) saturate(10) hue-rotate(180deg)",
                            }}
                            src="/img/ic_prev.svg"
                            alt=""
                          />
                        </button>

                        <button
                          className={`button2  px-4 p-2 ${
                            activeIndex === artists.length - 2 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            setActiveIndex((prev) =>
                              Math.min(prev + 1, artists.length - 1)
                            )
                          }
                        >
                          <img
                            style={{
                              height: "50px",
                              filter:
                                "invert(1) sepia(1) saturate(10) hue-rotate(180deg)",
                            }}
                            src="/img/ic_next.svg"
                            alt=""
                          />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </li>
            ) : null;
          })}
        </ul>
      </div>
    </div>
  );
};

export default Blessings;
